import React, { useEffect, useState } from "react";
import Style from "./SidebarMenuPeyk.module.scss";
import { getInfoAPI } from "../../../Api/PanelAdminServices";
import { errorToast } from "../../../Utils/Toast/Toast";
import OrdersAccardion from "./OrdersAccardion/OrdersAccardion";
const  SidebarMenuPeyk = () => {
  const [info,setInfo]=useState([])

  useEffect(()=>{
    getAdminInfo()
  },[])

  const getAdminInfo=async()=>{
    getInfoAPI((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setInfo(res.admin)
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  }
  return (
    <div className={Style.componentHandler} >
      <div className={Style.userInfo}>
        <div className={Style.namePhone}>
          <h2 className={Style.name}>{info.first_name + ' '+ info.last_name}</h2>
          <h3 className={Style.phone}>{info.phone}</h3>
        </div>
        <div className={Style.imgHolder}>
          <img src={`Assets/Images/Profile/img.jpg`} alt="" />
        </div>
      </div>
      <div className={Style.accardion}>
        <OrdersAccardion/>
        {/* <Accardion2/>
        <Accardion3/>
        <Accardion4/>
        <Accardion5/>
        <Accardion6/>
        <Accardion7/>
        <Accardion8/>
        <Accardion9/>
        <Accardion10/> */}
      </div>
    </div>
  );
};

export default  SidebarMenuPeyk;